import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../../ui/dialog.tsx';
import { Button } from '../../ui/button.tsx';
import { useRestoreSubAccount } from '../../../hooks/useSubAccounts.ts';
import { useState } from 'react';
import { Loader2, RotateCcw } from 'lucide-react';

interface RestoreDialogProps {
  user_id: string;
  email: string;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

function RestoreDialog({ user_id, email, isOpen, setIsOpen }: RestoreDialogProps) {
  const [isConfirming, setIsConfirming] = useState(false);
  const restoreSubAccount = useRestoreSubAccount();

  const handleRestore = async () => {
    if (!user_id) return;

    setIsConfirming(true);
    try {
      await restoreSubAccount.mutateAsync(user_id);
      setIsOpen(false);
      setIsConfirming(false);
    } catch (error) {
      setIsConfirming(false);
    }
  };

  const handleCancel = () => {
    if (isConfirming) return;
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <RotateCcw className="size-5 text-green-600" />
            Restore Sub-Account
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to restore the account for <strong>{email}</strong>?
            <br />
            <br />
            This will reactivate the account and the user will be able to access the platform again.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={handleCancel}
            disabled={isConfirming}
          >
            Cancel
          </Button>
          <Button
            onClick={handleRestore}
            disabled={isConfirming}
            className="bg-green-600 hover:bg-green-700 text-white"
          >
            {isConfirming ? (
              <>
                <Loader2 className="size-4 mr-2 animate-spin" />
                Restoring...
              </>
            ) : (
              <>
                <RotateCcw className="size-4 mr-2" />
                Restore Account
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default RestoreDialog;